export default {
    //AcademyComponent
    customization: 'Personaliza tu academia',
    sections: 'Secciones de personalización',
    // Secciones del menú lateral: cada descripción nombra solo lo que hay en esa pantalla.
    identity: 'Identidad',
    identity_description: 'Nombre, eslogan, logo y favicon',
    design: 'Diseño',
    design_description: 'Colores y tipografías',
    home: 'Portada',
    home_description: 'Encabezado, banner y descripción',
    description_location_help: 'Dónde se ve: con el encabezado «2 Columnas, Texto + Imagen» aparece junto a la imagen, arriba de la portada. Con los encabezados de banner a tamaño completo aparece en la sección de contacto, al final de la portada.',
    menu_section_description: 'Enlaces del menú de la web',
    contact_social: 'Contacto y redes',
    contact_description: 'Contacto, redes y HTML propio',
    legal_description: 'Privacidad y aviso legal',
    settings: 'Ajustes',
    settings_description: 'Dominio, idioma y scripts',
    domain: "Dominio",
    brand_logo: "Marca",
    rrss_contact: "Contacto",
    legal: "Legal",
    options: 'Opciones',

    //DomainComponent
    your_domain: "Crea tu dominio público: tuacademia.mybrainspro.com",
    example_url_placeholder: 'https://',
    example_2: '.mybrainspro.com',
    info_domain: "Escribe el dominio SIN símbolos (.,-¿?!·$%&/()...), ni acentos ni espacios en blanco. No hace falta que pongas www.",
    domain_input: "Dominio mybrainspro.com",
    custom_domain: "Dominio corporativo",
    domain_text: 'Dominio',
    info_domain2: "Introduce tu dominio (www.tudominio.com) para utilizarlo como página principal o como página secundaria (tuacademia.tudominio.com)",
    attention: "Atención",
    info_attention: "Sólo disponible para a partir del plan Pro Trainer",
    activate_domain: "Para activar tu dominio en BrainsPro: ",
    info_activate_1line: "Visita la plataforma donde compraste tu dominio y busca la configuración de DNS.",
    info_activate_2line: "Añade el registro de tipo A a la IP: 76.223.11.227",
    info_activate_3line: "Crea un ticket escribiendo a soporte{'@'}brainspro.com para solicitar la activación del dominio. Ten en cuenta que pueden pasar 48 horas hasta que estos cambios se hagan efectivos y se propagen en tu DNS. Una vez listo, ya puedes comenzar a utilizar la nueva dirección de tu academia online en BrainsPro.",
    info_activate_4line: "Recibirás en tu correo electrónico los registros adicionales que tendrás que colocar en tus DNS para generar tu web segura (https://)",
    example_academy: 'academia-de-ejemplo',
    example_domain: 'miacademia.com',
    //LanguageSelector
    lang: 'Idioma',
    academy_lang: 'Idioma de la Academia',
    academy_lang_selector_text: 'Elige el idioma de tu academia',

    //BrandingComponent
    banner: 'Imagen de cabecera',
    brand_academy: "Nombre y eslogan de la Academia",
    academy_name: "Nombre de Academia",
    full_name: "Elige el nombre completo de tu academia",
    tagline: "Eslogan de la academia",
    slogan: "Escribe un eslogan o tu propuesta de valor en una frase",
    tagline_placeholder: "Escribe aquí tu eslogan",
    search: 'Buscar',
    my_academy: 'Pon aqui el nombre de tu academia',
    change: 'Cambiar',
    insert: 'Insertar',
    href_custom_academy: 'Más sobre personalizar tu academia.',

    //ContactComponent
    description: "Descripción",
    web_rrss: "Información de contacto",
    web_blog: "Web o Blog",
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "Linkedin",
    youtube: "Youtube",
    location: "Ubicación y datos Fiscales",
    address_line_1: "Dirección, línea 1",
    address_line_2: "Dirección, línea 2",
    postalcode: "Código Postal",
    city: "Ciudad",
    province: "Provincia",
    country: "País",
    company_name: "Denominación Social",
    nif_cif: "NIF/CIF",

    //LegalComponent
    privacy_policy: "Política de Privacidad",
    text_register: "Texto resumen para registro de usuario",
    user_view_text: "Este texto se mostrará en el regisro de usuario, a modo de resumen de la versión más extensa que se mostrará en la página de aviso legal de tu academia.",
    privacy_policy_page: "Página de Política de Privacidad",
    privacy_policy_academy_page: "Página de Política de Privacidad de la academia",
    legal_notice: "Aviso Legal",
    href_legal: 'Más sobre Aviso Legal y Política de Privacidad.',

    //Contact
    contact_bloq: 'HTML Personalizado',
    html_bloq: 'En este espacio puedes insertar cualquier tipo de contenido en HTML para acompañar a la información de contacto. Video embebido, Imagen, Mapa de localización...',

    //Branding
    //BannerBrandingComponent
    upload_banner: 'Sube tu banner o imagen de cabecera',
    image_format: 'PNG, JPG, GIF hasta 3MB',
    banner_size_recommendation: 'Recomendado: imagen panorámica, de al menos 1600×600 px. En pantallas pequeñas se mostrará completa; en pantallas grandes se recortará para ocupar todo el ancho.',

    //ColorsComponent
    desing_colors: 'Diseño y Colores',
    header_type: 'Selecciona el tipo de encabezado',
    banner_complete: 'Banner a tamaño completo con el nombre de la academia y eslogan superpuestos',
    banner_complete_no_text: 'Banner a tamaño completo sin textos',
    columns_text_image: '2 Columnas, Texto + Imagen',
    banner_info: 'Con esto cambiarás el tipo de imagen de portada que verán los usuarios en tu academia.',
    enterprise_color: 'Color corporativo',
    text_color: 'Color de texto',

    //FontsComponent
    desing_fonts: 'Tipografía',
    fonts_info: 'Elige la fuente que se usará en cada tipo de texto de tu academia.',
    font_h1: 'Título principal (H1)',
    font_h2: 'Subtítulo (H2)',
    font_h3: 'Título de sección (H3)',
    font_body: 'Texto normal',
    font_default: 'Por defecto',

    //FaviconComponent
    favicon: 'Favicon',
    favicon_help: 'Icono que aparece en la pestaña del navegador.',
    upload_favicon: 'Sube tu favicon',
    favicon_format: 'PNG, JPG, GIF hasta 3MB',

    //LogoBrandingComponent
    logo: 'Logo',
    logo_help: 'Aparece en la cabecera de la web y en los certificados.',
    upload_logo: 'Sube tu logo',

    //OptionsComponent
    register_config: 'Configuración de Registro',
    info_button_register: 'Al activar este botón se desactivará la opción de registrarse en la academia. Para ello todos los usuarios deberán registrarse desde la App de Brainspro.',
    restricted_register: 'Restricción de registro',

    //MenuComponent
    menu: 'Menú',
    menu_description: 'Elige qué enlaces aparecen en el menú superior de la web de tu academia y en qué orden.',
    menu_default_notice: 'Todavía no has añadido ningún elemento, así que tu web está usando el menú por defecto. En cuanto añadas uno, el menú mostrará solo los elementos de esta lista.',
    add_menu_item: 'Añadir elemento',
    edit_menu_item: 'Editar elemento',
    menu_item_edit: 'Editar',
    menu_item_type: 'Tipo',
    menu_item_type_catalog: 'Catálogo',
    menu_item_type_contact: 'Contacto',
    menu_item_type_page: 'Página',
    menu_item_type_link: 'Enlace',
    menu_item_type_home: 'Inicio',
    menu_item_type_home_help: 'Lleva a la página principal de tu academia.',
    menu_item_type_catalog_help: 'Lleva a la página con todos tus cursos.',
    menu_item_type_contact_help: 'Lleva a la sección de contacto de tu página de inicio.',
    menu_item_type_link_help: 'Lleva a cualquier dirección web que escribas.',
    menu_item_title: 'Texto del enlace',
    menu_item_add_translations: 'Añadir nombre en otros idiomas',
    menu_item_hide_translations: 'Ocultar nombres en otros idiomas',
    menu_item_translations: 'Nombre en otros idiomas',
    menu_item_translations_example: 'Ejemplo: si el enlace se llama "Cursos", en inglés puedes escribir "Courses".',
    menu_item_page: 'Página',
    menu_item_select_page: 'Elige una página',
    menu_item_page_invalid: 'La página de este elemento ya no está disponible. Elige otra para poder guardar.',
    menu_pages_loading: 'Cargando páginas…',
    menu_pages_error: 'No se han podido cargar las páginas de la academia.',
    menu_no_pages: 'Todavía no tienes páginas. Escríbenos a soporte y te ayudamos a crearlas.',
    menu_page_unavailable: 'Página no disponible',
    menu_page_unavailable_help: 'La página de este elemento ya no existe, así que no se muestra en la web. Edítalo para elegir otra.',
    menu_item_url: 'URL',
    menu_item_url_help: 'Debe empezar por https:// o http://.',
    menu_item_visible: 'Visible en la web',
    menu_item_hidden: 'Oculto',
    move_menu_item_up: 'Subir elemento',
    move_menu_item_down: 'Bajar elemento',
    drag_menu_item: 'Arrastra para reordenar',
    delete_menu_item: 'Eliminar elemento del menú',
    delete_menu_item_confirm: 'Se eliminará «{title}» del menú. Esta acción no se puede deshacer.',
    menu_item_saved: 'El elemento del menú se ha guardado',
    menu_item_deleted: 'El elemento se ha eliminado del menú',
    menu_order_saved: 'Se ha guardado el orden del menú',
    menu_order_error: 'No se ha podido guardar el orden del menú. Se ha restaurado el orden anterior.',
    menu_unexpected_error: 'Ha ocurrido un error inesperado con el menú',
    menu_item_name_es: 'Nombre en español',
    menu_item_name_en: 'Nombre en inglés',
    menu_item_name_ca: 'Nombre en catalán',
    menu_item_name_de: 'Nombre en alemán',
    menu_item_name_pt: 'Nombre en portugués',

}